export const STATUS_CONFIG = {
    COMPLETED: {
      label: "Completed",
      color: "bg-green-100 text-green-700 border-green-300",
      description: "The verification process has been successfully completed."
    },
  
    PENDING_ON_ISSUER: {
      label: "Pending on Issuer",
      color: "bg-yellow-100 text-yellow-700 border-yellow-300",
      description: "Awaiting confirmation or action from the issuing authority."
    },
  
    PENDING_ON_HOLDER: {
      label: "Pending on Holder",
      color: "bg-yellow-100 text-yellow-700 border-yellow-300",
      description: "Waiting for required information or action from the holder."
    },
  
    FNF_PENDING: {
      label: "FNF Pending",
      color: "bg-orange-100 text-orange-700 border-orange-300",
      description: "Full and Final settlement is pending."
    },
  
    RECOVERY_PENDING: {
      label: "Recovery Pending",
      color: "bg-orange-100 text-orange-700 border-orange-300",
      description: "Outstanding recoveries need to be cleared."
    },
  
    EMPLOYEE_ABSCONDING: {
      label: "Employee Absconding",
      color: "bg-red-100 text-red-700 border-red-300",
      description: "Employee left without completing exit formalities."
    },  
    REJECTED: {
      label: "Rejected",
      color: "bg-red-100 text-red-700 border-red-300",
      description: "The verification request has been rejected."
    },
    
  
    NOT_AN_EMPLOYEE: {
      label: "Not an Employee",
      color: "bg-gray-100 text-gray-700 border-gray-300",
      description: "The individual was never employed with the organization or the entered employee id is incorrect."
    },
  
    ACTIVE_EMPLOYEE: {
      label: "Active Employee",
      color: "bg-green-100 text-green-700 border-green-300",
      description: "The individual is currently employed."
    },
    DETAILS_SHARED_OVER_EMAIL: {
        label: "Details Shared Over Email",
        color: "bg-green-100 text-green-900 border-green-300",
        description: "The request has been responded and the employee details are shared on the registered email."
      },

      DETAILS_NEEDED: {
        label: "Details Needed",
        color: "bg-yellow-100 text-yellow-900 border-green-300",
        description: "The verifier did not receive complete details and has raised a request on the WorkAttest portal for the issuer to issue the required document."
      },
      APPEAL_APPROVED: {
        label: "Appeal Approved",
        color: "bg-green-100 text-green-900 border-gray-300",
        description: "The document discrepency appeal has been approved."
      },
    APPEAL_CLOSED: {
      label: "Appeal Closed",
      color: "bg-gray-100 text-blue-600 border-gray-300",
      description: "The appeal case is closed and no further action is required."
    },
    APPEAL_RAISED: {
        label: "Appeal Raised",
        color: "bg-gray-100 text-red-600 border-gray-300",
        description: "The document discrepancy appeal has been raised on the issuer’s side and is currently under review."
      }
  }
